import ur from "./ur";
import { useState } from 'react';
const SUBMIT_PANEL_NUMBERING = "submitPanelNumbering";

export default function PublicationPanelOrderText({editorState,number, onEvent,figurePanelId,editing,
  getNameChangeConflict,
}){

  

  const [ localNumber, setLocalNumber ] = useState(number);

  let [ numeral, letter, roman ] = (localNumber||"").split('.');

  const newNumber = ([numeral,letter,roman].filter(x => x && x.trim().length > 0).join('.'))


  let conflict = getNameChangeConflict({
    figurePanelId,
    newNumber,
  })



  let titleStyle = (!number) ? ({color:'red', fontStyle:'italic'}) : {};

  //second dot gets a space
  let title;
  if( number ){
    title = "Figure " + number?.replace?.(".","")?.replace?.("."," ");
  }else{
    title = "Click to set figure number"
  }


  if( !editing ){
    return (
      <div class="sg-row">
        <div style={{ ...titleStyle, fontWeight:'bold',
          fontSize:16,
          }}
          class="round-corners hoverable clickable" onClick={() => {

            onEvent({
              type:"editPanelNumber",
              figurePanelId,
            })

          }}>
          {title}
        </div>
      </div>
    )
  }else{

    let items = [
      { title:"Number", value:numeral, }, 
      { title:"Letter", value:letter },
      { title:"Numerals", value:roman }
    ]

    return (
      <div>

        <div class="sg-row">
          {items.map(({title,value},ii) => {

            let disabled = false;
            if( ii === 1 ){
              disabled = !numeral;
            }else if( ii === 2 ){
              disabled = !letter;
            }

            return (
              <div>
                <div><input 
                  value={disabled?"":value}
                  disabled={disabled}
                  style={{width:30}} onChange={(e) => {

                    let newLocalNumber = items.map((it,jj) => {
                      return ii===jj?e.target.value:it.value
                    }).filter(x => x).join('.')

                    setLocalNumber(newLocalNumber);

                    let { value } = e.target;
                  }}/></div>
              </div>
            )
          })}

          <div><button onClick={() => {
            
            /*if( conflict ){
              onEvent({
                type:"endPanelNumberEditing",
              })
                
            }
            */
            onEvent({
              type:"submitPanelNumbering",
              figurePanelId,
              newNumber
            });

          }}>{conflict?"Cancel":"Done"}</button></div>

          <div style={{color:'red',fontSize:24}}>
            {conflict ? JSON.stringify(conflict) : "NO CONFLICT"}
          </div>


        </div>

      </div>
    )
  }


}
